import { MenuItems } from '../types/MenuItems';

export const isMenuPageOpen = () => {
  const { hash } = window.location;

  return (
    hash.includes(MenuItems.LOGIN) ||
    hash.includes(MenuItems.REGISTER) ||
    hash.includes(MenuItems.TOGETHER)
  );
};
